import { render, staticRenderFns } from "./ViewAllDetailsOrderItem.vue?vue&type=template&id=6be02804&scoped=true"
import script from "./ViewAllDetailsOrderItem.vue?vue&type=script&lang=js"
export * from "./ViewAllDetailsOrderItem.vue?vue&type=script&lang=js"
import style0 from "./ViewAllDetailsOrderItem.vue?vue&type=style&index=0&id=6be02804&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be02804",
  null
  
)

export default component.exports